import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@akuna/ui";
import { Input } from "@akuna/ui";
import { RichTextEditor } from "@/components/terms/RichTextEditor";

export type TermEditDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Display name of the template used (read-only) */
  templateName?: string | null;
  titleDraft: string;
  onTitleChange: (value: string) => void;
  contentDraft: string;
  onContentChange: (value: string) => void;
  onSave: () => void;
  isSaving: boolean;
};

export const TermEditDialog = ({
  open,
  onOpenChange,
  templateName,
  titleDraft,
  onTitleChange,
  contentDraft,
  onContentChange,
  onSave,
  isSaving,
}: TermEditDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-3xl">
        <DialogHeader>
          <DialogTitle>Editar Termo</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {templateName && (
            <div className="space-y-1">
              <p className="text-sm font-medium text-muted-foreground">Modelo</p>
              <p className="text-sm text-foreground">{templateName}</p>
            </div>
          )}
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">Título</p>
            <Input
              value={titleDraft}
              onChange={(event) => onTitleChange(event.target.value)}
              placeholder="Título do termo"
            />
          </div>
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">
              Texto do termo (conteúdo para impressão)
            </p>
            <RichTextEditor
              value={contentDraft}
              onChange={onContentChange}
              placeholder="Conteúdo do termo..."
              minHeightClassName="min-h-[280px]"
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSaving}
          >
            Cancelar
          </Button>
          <Button type="button" onClick={onSave} disabled={isSaving}>
            {isSaving ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
